export const projects = [
    {
        title: "Portfolio page",
        subtitle: "CSS/SASS/HTML5",
        description:
            "Created a sleek portfolio website using SASS, Flexbox, Animation with keyframes and transitions and overlays",
        image: "./project-1.png",
        link: "https://portfolioaw.s3.amazonaws.com/css-portfolio/index.html",
    },
    {
        title: "News grid",
        subtitle: "CSS/HTML5",
        description:
            "Created a responsive and dynamic journal home page using media query, CSS grid, Flexbox.",
        image: "./project-2.png",
        link: "https://inspiring-heisenberg-42b128.netlify.app",
    },
    {
        title: "Food ordering App",
        subtitle: "React and Firebase",
        description:
            "Created food ordering app with React and custom hooks. Established connection with Firebase calling APIs to pull the menu from the backend. Created checkout cart and ordering form with input validation",
        image: "./project-3.png",
        link: "https://portfolioaw.s3.amazonaws.com/food-app/build/index.html",
    },
    {
        title: "Meetups List",
        subtitle: "NextJS",
        description:
            "Created an app to generate meetups with NextJS using MongoDB as a back-end database. Apps allows users to add their own meetup while the back end creates a new dynamic route and adds to the database.",
        image: "./project-4.png",
        link: "https://next-js-meetup-v1.vercel.app",
    },
];


export const skills = [
    "React",
    "JavaScript",
    "HTML5",
    "Git",
    "TypeScript",
    "CSS/SASS",
    "Next.js",
    "Jest"
];



// WEBPACK FOOTER //
// ./src/data.js